module.exports = __webpack_public_path__ + "static/media/fdjlogo.8e1a395f.png";